(() => {
  const titlePattern = /^(?:להודיע|הודיעו|תודיע|תודיעו)\s+לי\s+דרך\s*:?\s*$/;
  function findTitle(modal) {
    const known = modal.querySelector('.restock-alerts-modal-title');
    if (known && !known.querySelector('button,[role="button"],[class*="close"]')) return known;
    const options = modal.querySelectorAll('h1,h2,h3,h4,span,p,strong,b,div');
    for (const el of options) {
      if (!titlePattern.test((el.textContent || '').trim())) continue;
      if (el.querySelector('button,[role="button"],[class*="close"]')) continue;
      if (Array.from(el.children).some(ch => titlePattern.test((ch.textContent || '').trim()))) continue;
      return el;
    }
    return null;
  }
  function adjust() {
    document.querySelectorAll('.restock-alerts-modal-box').forEach(modal => {
      const title = findTitle(modal);
      if (!(title instanceof HTMLElement) || title.dataset.rtlNotifyHeadingV4) return;
      const display = getComputedStyle(title).display;
      if (display === 'inline') title.style.setProperty('display', 'inline-block', 'important');
      title.style.setProperty('transform', 'translateX(-46px)', 'important');
      title.style.setProperty('transform-origin', 'right center', 'important');
      title.style.setProperty('white-space', 'normal', 'important');
      title.dataset.rtlNotifyHeadingV4 = '1';
    });
  }
  let pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; adjust(); });
  }
  function start() {
    if (document.documentElement.dir !== 'rtl' && !/^he(?:-|$)/i.test(document.documentElement.lang)) return;
    schedule();
    new MutationObserver(mutations => {
      if (mutations.some(m => m.addedNodes.length || m.removedNodes.length)) schedule();
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();